import { useRef } from 'react'
import { useTheme } from 'next-themes'
import { useRipple } from '@/hooks/useRipple'
import { useMounted } from '@/hooks/useMounted'

const DarkModeButton = () => {
  const { resolvedTheme, setTheme } = useTheme()

  const isMounted = useMounted()

  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  const handleClick = () => {
    resolvedTheme === 'light' ? setTheme('dark') : setTheme('light')
  }

  return (
    <>
      <button
        ref={ref}
        className="hover:opacity-80 relative w-10 h-10 p-2 overflow-hidden rounded-full"
        onClick={handleClick}
      >
        {isMounted && (
          <>
            {resolvedTheme === 'light' ? (
              <SunSvg fill={'#323e48'} />
            ) : (
              <MoonSvg fill={'#e0e0e0'} />
            )}
          </>
        )}
      </button>
    </>
  )
}
const SunSvg = ({ fill = 'black' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
    <path d="M120.2 154.2c4.672 4.688 10.83 7.031 16.97 7.031S149.5 158.9 154.2 154.2c9.375-9.375 9.375-24.56 0-33.93L108.9 74.97c-9.344-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L120.2 154.2zM256 112c13.25 0 24-10.75 24-24v-64C280 10.75 269.3 0 256 0S232 10.75 232 24v64C232 101.3 242.8 112 256 112zM112 256c0-13.25-10.75-24-24-24h-64C10.75 232 0 242.8 0 256s10.75 24 24 24h64C101.3 280 112 269.3 112 256zM374.8 161.2c6.141 0 12.3-2.344 16.97-7.031l45.25-45.28c9.375-9.375 9.375-24.56 0-33.94s-24.59-9.375-33.94 0l-45.25 45.28c-9.375 9.375-9.375 24.56 0 33.93C362.5 158.9 368.7 161.2 374.8 161.2zM256 400c-13.25 0-24 10.75-24 24v64C232 501.3 242.8 512 256 512s24-10.75 24-24v-64C280 410.8 269.3 400 256 400zM120.2 357.8l-45.25 45.28c-9.375 9.375-9.375 24.56 0 33.94c4.688 4.688 10.83 7.031 16.97 7.031s12.3-2.344 16.97-7.031l45.25-45.28c9.375-9.375 9.375-24.56 0-33.93S129.6 348.4 120.2 357.8zM488 232h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C501.3 280 512 269.3 512 256S501.3 232 488 232zM391.8 357.8c-9.344-9.375-24.56-9.372-33.94 .0031s-9.375 24.56 0 33.93l45.25 45.28c4.672 4.688 10.83 7.031 16.97 7.031s12.28-2.344 16.97-7.031c9.375-9.375 9.375-24.56 0-33.94L391.8 357.8zM256 144C194.1 144 144 194.1 144 256c0 61.86 50.14 112 112 112s112-50.14 112-112C368 194.1 317.9 144 256 144z" />
  </svg>
)
const MoonSvg = ({ fill = 'black' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
    <path d="M32 256c0-123.8 100.3-224 223.8-224c11.36 0 29.7 1.668 40.9 3.746c9.616 1.777 11.75 14.63 3.279 19.44C245 86.5 211.2 144.6 211.2 207.8c0 109.7 99.71 193 208.3 172.3c9.561-1.805 16.28 9.324 10.11 16.95C387.9 448.6 324.8 480 255.8 480C132.1 480 32 379.6 32 256z" />
  </svg>
)
export default DarkModeButton
